import { isNullOrUndefinedOrEmpty } from 'rewire-common';
import { Modal, Form, IFormContext } from 'rewire-ui';
import DataMutations from '../graphql/Mutations';
import DataQueries from '../graphql/Queries';
import { notifications } from '../ui/Notifications';
import { roleSearcher, getNameSearcher } from '../utility/Searchers';
import { ILocation, IEmployee, InvitationInput } from '../DataTypes';
import billingLinkDialogModel from './BillingLinkDialogModel';
import mainPageModel from '../main-navigation/MainPageModel';

// TODO: make area selection a multiselection autocomplete, and have the graphql support that.

class InviteDialogModel extends Modal {
  form: Form;

  constructor() {
    super('');

    const employeeSearcher = getNameSearcher('employees', undefined, 'id name code display other', (item: any) =>
      Object.assign(item, item?.other),
    );

    this.form = Form.create((form: IFormContext) => ({
      email: form
        .email()
        .label('Email Address')
        .validators('required')
        .placeholder('enter an email address')
        .disabled(() => this.isEmployeeRole && !isNullOrUndefinedOrEmpty(this.form.field.employee.value?.email))
        .autoFocus(),
      role: form.select(roleSearcher).label('User Role').validators('required'),
      employee: form
        .reference(employeeSearcher)
        .label('Employee')
        .validators('required')
        .disabled(() => !this.isEmployeeRole)
        .onValueChange(this.handleEmployeeChange),
    }));
    this.action('cancel', { variant: 'text' }).action('send invite', this.submit, { type: 'submit' });
  }

  reset() {
    this.form.reset();
  }

  load() {
    this.reset();
    this.open();
  }

  get isEmployeeRole() {
    return this.form.field.role.value?.code === 'employee';
  }

  handleEmployeeChange = (_form: Form, v?: IEmployee) => {
    if (v && !isNullOrUndefinedOrEmpty(v.email)) {
      this.form.setFieldValue('email', v.email);
    }
  };

  private save = async (): Promise<boolean> => {
    const userRole = this.form.field.role.value?.code;

    if (userRole !== 'employee' && userRole !== 'none') {
      const currLocation = (
        await DataQueries.getLocationsByIds('id activeUsers subscriptionCount planAdministrator { id }', [
          mainPageModel.location.id,
        ])
      )?.[0];
      if (!currLocation) return false;

      const { activeUsers, subscriptionCount } = currLocation as ILocation;
      if (activeUsers >= subscriptionCount) {
        if (currLocation.planAdministrator?.id === mainPageModel.userId) {
          billingLinkDialogModel.load();
        } else {
          notifications.error(
            'You have no more users available in your subscription. Please contact your plan administrator to add more users.',
          );
        }

        return false;
      }
    }

    const invitationInput: InvitationInput = {
      inviteTo: this.form.field.email.value,
      userRole: userRole,
    };
    const result = await DataMutations.invite(invitationInput);

    if (result) {
      notifications.success('Invitation Sent');
      return true;
    }

    notifications.error('Invitation Failed');
    return false;
  };

  submit = async () => {
    return await this.form.submitAsync(this.save);
  };
}

const inviteDialogModel = new InviteDialogModel();
export default inviteDialogModel;
